import * as React from "react";
import { Controller } from "react-hook-form";
import FormHelperText from "@mui/material/FormHelperText";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box, Typography } from "@mui/material";

const FormDatePicker = ({ name, control, label, rules, sx }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <Box sx={{ display: 'flex', gap: 12, p: 2, alignItems: 'center', ...sx }}>
            {label && (
              <Typography>{label}</Typography>
            )}
            <DatePicker
              {...field}
              slotProps={{
                textField: {
                  size: "small",
                  error: !!fieldState.error,
                  sx: { width: 384, height: 40 },
                },
              }}
              format="MM/DD/YYYY"
              autoOk
            />
            <FormHelperText sx={{ color: '#ef4444' }}>{fieldState.error?.message}</FormHelperText>
          </Box>
        )}
      />
    </LocalizationProvider>
  );
};

export default FormDatePicker;
